import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "h-12 rounded-none border-white/10 bg-white/5 text-sm text-stone-100 placeholder:text-stone-500 focus-visible:ring-0 focus-visible:border-brand/60";

const LeadForm = ({ tipo = "contato", imovelSlug = null, testidPrefix = "lead" }) => {
  const [form, setForm] = useState({ nome: "", email: "", telefone: "", data_visita: "", mensagem: "" });
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/leads`, {
        nome: form.nome,
        email: form.email,
        telefone: form.telefone || null,
        mensagem: form.mensagem || null,
        tipo,
        imovel_slug: imovelSlug,
        data_visita: form.data_visita || null,
      });
      toast.success(
        tipo === "visita"
          ? "Visita solicitada! Em breve entraremos em contato para confirmar o horário."
          : "Mensagem enviada! Em breve entraremos em contato."
      );
      setForm({ nome: "", email: "", telefone: "", data_visita: "", mensagem: "" });
    } catch (err) {
      toast.error("Não foi possível enviar. Verifique os dados e tente novamente.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid={`${testidPrefix}-form`}>
      <div className="grid gap-4 sm:grid-cols-2">
        <Input
          required
          data-testid={`${testidPrefix}-nome-input`}
          placeholder="Nome completo"
          value={form.nome}
          onChange={set("nome")}
          className={inputCls}
        />
        <Input
          required
          type="email"
          data-testid={`${testidPrefix}-email-input`}
          placeholder="E-mail"
          value={form.email}
          onChange={set("email")}
          className={inputCls}
        />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <Input
          data-testid={`${testidPrefix}-telefone-input`}
          placeholder="Telefone / WhatsApp"
          value={form.telefone}
          onChange={set("telefone")}
          className={inputCls}
        />
        {tipo === "visita" ? (
          <Input
            type="date"
            data-testid={`${testidPrefix}-data-input`}
            value={form.data_visita}
            onChange={set("data_visita")}
            className={`${inputCls} [color-scheme:dark]`}
          />
        ) : (
          <div className="hidden sm:block" />
        )}
      </div>
      <Textarea
        data-testid={`${testidPrefix}-mensagem-input`}
        placeholder={tipo === "visita" ? "Melhor dia e horário para você, dúvidas sobre o imóvel..." : "Conte o que você procura: comprar, vender, alugar ou financiar..."}
        value={form.mensagem}
        onChange={set("mensagem")}
        rows={4}
        className="rounded-none border-white/10 bg-white/5 text-sm text-stone-100 placeholder:text-stone-500 focus-visible:ring-0 focus-visible:border-brand/60"
      />
      <button
        type="submit"
        disabled={sending}
        data-testid={`${testidPrefix}-submit-button`}
        className="group inline-flex items-center gap-3 bg-brand px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-brand-light disabled:opacity-60"
      >
        {sending ? "Enviando..." : tipo === "visita" ? "Agendar Visita" : "Enviar Mensagem"}
        <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </form>
  );
};

export default LeadForm;
